<bon-list-tous-site-globale-datagrid
  #bonListGlobaleDatagridComponent
  *ngIf="selectedLieuStockage == null"
  [fluxEtapeDataSource]="fluxEtapeDataSource"
  [bonStore]="bonStore"
  [isMultiSite]="true"
></bon-list-tous-site-globale-datagrid>


